import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { StudioControlStyles } from '../styles';
import SliderAction from './SliderAction';
import { PrompterConfig } from '../utils';
import { setScrollSpeed } from '../../../store/modules/studio/actions';
import { selectScrollSpeed } from '../../../store/modules/studio/selectors';

const ScrollSpeedAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const currentScrollSpeed = useSelector(selectScrollSpeed);
  const onChange = useCallback((e: React.ChangeEvent<{}>, speed: number | number[]) => {
    if (!Array.isArray(speed)) {
      dispatch(setScrollSpeed(speed));
    }
  }, [dispatch]);

  return (
    <Grid item>
      <p className={classes.label}>Scroll Speed</p>
      <SliderAction
        value={currentScrollSpeed}
        onChange={onChange}
        step={PrompterConfig.speedDelta}
        min={PrompterConfig.minSpeed}
        max={PrompterConfig.maxSpeed}
        valueLabelDisplay="auto"
      />
    </Grid>
  );
};

export default ScrollSpeedAction;
